var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueLightIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#445e84;}.cls-3{fill:#6a98d0;}.cls-4{fill:#1f242d;}.cls-5{fill:#181c20;}.cls-6{fill:#37496c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.93C517.13,227.58,318.89,21.48,311,13.15c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.08-14.29-.8-14.29-.8S263.09,5,249.41,9C233.58,13.53,7.86,70.89,7.86,70.89S.77,72.71.69,80,0,124.73,0,124.73,195.25,376.11,202.91,386.07c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,232,519.39,229.93ZM424.1,172.26l-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L425.94,165C428.58,167.78,427.75,171.06,424.1,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.44,185.58c-1.89-2-167.09-173.72-173.71-180.65-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.91-.66-11.91-.66s-3.29-4.36-14.69-1.07C247.26,5.24,59.16,53,59.16,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S215.32,307.39,221.7,315.69c5.23,6.83,18.36,2.08,18.36,2.08S476.79,232,482.31,229.92c4.84-2.07,4.49-6.38,4.49-6.38l.11-31.59S487.08,187.34,485.44,185.58ZM424.1,172.26l-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L425.94,165C428.58,167.78,427.75,171.06,424.1,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M482.82,182.73S318.35,11.75,311.73,4.81c-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S271.85-2,260.45,1.31C247.26,5.12,59.16,52.93,59.16,52.93s-8.71,3-3.6,9.42c5.37,7.05,48.6,63.65,48.6,63.65s107.5,135.24,115.55,145.29,23.12,3.88,23.12,3.88,227.05-77.39,237.78-81S482.82,182.73,482.82,182.73ZM424.1,172.26l-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L425.94,165C428.58,167.78,427.75,171.06,424.1,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "244.52 281.15 244.52 308.67 477.33 224.48 477.33 201.17 244.52 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "477.33 201.17 460.99 206.84 477.33 224.48 477.33 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.86,128.13l-7.76,1.57c17.27,21.72,105.35,132.53,112.61,141.59A15.6,15.6,0,0,0,231.46,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M482.82,182.73S412.29,109.41,361.75,56.84l-4.09,1.74L485.08,191.4C488.11,187.58,482.82,182.73,482.82,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.4,58.53c-8.48,2.19-26.72,8.67-16.64,21.56s24.93,13.26,42.42,8.43,132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8-30.42-8.71-44.77-4.92S127.88,56.33,119.4,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.81,13.22l-2-2-25.09,6.74a30.56,30.56,0,0,1,3.68,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.19,70.72,67.5,78.07l1.92,2.51,25.79-6.91A9.14,9.14,0,0,1,95.19,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324,17.6l-1.95-2-22.27,6a28.92,28.92,0,0,1,2.44,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71,82.62l1.92,2.5,24.24-6.47A16.56,16.56,0,0,1,95.88,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.35,27.77l21.75-5.92-1.94-2-21.6,5.86c.31.33.63.67.94,1S306.08,27.42,306.35,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99,81.29,74.92,87.8l1.94,2.49L101,83.7c-.48-.53-1-1.08-1.42-1.65C99.36,81.79,99.18,81.54,99,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.64,92.56l1.94,2.49,25.17-6.89c-.87-.69-1.74-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.19,26.1l-1.94-2L308,30.14a17,17,0,0,1,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.84,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310,37.37l26.16-7.16-1.93-2L309.9,34.82A8.49,8.49,0,0,1,310,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M432,165.28,332.44,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.18,4.17l190.16-63.39C434.38,173.1,435.44,168.87,432,165.28Zm-7.94,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L425.94,165C428.58,167.78,427.75,171.06,424.1,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.87,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.31-7.3c3.14-1,5.28.8,4.75,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLightIsometric);
export default __webpack_public_path__ + "static/media/blue-light-isometric.d5b5ecf52ef9f26fcdfc7d75b4151773.svg";
export { ForwardRef as ReactComponent };